import { render } from "./CltnTypeFilterComp.vue?vue&type=template&id=6548e73a&ts=true"
import script from "./CltnTypeFilterComp.vue?vue&type=script&lang=ts"
export * from "./CltnTypeFilterComp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__